import React, { useState, useEffect } from "react";
import {Link } from 'react-router-dom'
import axiosInstance from "../../../services/api";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../Commons/Loader';
import Select from "react-select";
function AddRole() {
    const history = useHistory();
    const [fetchPermission, setFetchPermission] = useState([]);
    const [errors, setErrors] = useState({});
    const [selectedItemsPermission, setSelectedItemsPermission] = useState([]);
    const [permissionId, setPermissionId] = useState([]);
    const [loading, setLoading] = useState(true);
    const fetchUserData = async () => {
        try {
            const response = await axiosInstance.get('user/role/add-edit-role'); // Fetch data
            const permissions = response.data?.data?.permissions || [];
            setFetchPermission(permissions);
    
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
          }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    useEffect(() => {

    }, [fetchPermission]);


    const [formData, setFormData] = useState({
        id:null,
        name:"",
        description: ""
    });
  
  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.name) {
      tempErrors.name = "Please type name";
      isValid = false;
    }
    if (!formData.description) {
        tempErrors.description = "Please type description";
        isValid = false;
    }
    if (selectedItemsPermission.length === 0) {
        tempErrors.selectedItemsPermission = "Please select at least one item";
        isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });

  };

  const permissionArr = fetchPermission.map(permission => ({
        id: permission.id,
        value: permission.name,  // Use hotelName as value
        label: permission.name   // Optionally, you can also use hotelName as the label
    }));
// console.log(permissionArr,"mainPermission")
  const handleChangePermission = (newSelectedPermission) => {
    if (permissionArr.length === 0) {
        console.error("Permissions not loaded yet.");
        return;
    }
    const selectedPermissionIds = newSelectedPermission.map(optionValue => {
        const selectedOptionRole = permissionArr.find(option => option.value === optionValue);
        return selectedOptionRole ? parseInt(selectedOptionRole.id, 10) : null;
    });
    //console.log(newSelectedPermission,"newSelectedPermission")
    setSelectedItemsPermission(newSelectedPermission);
    setPermissionId(selectedPermissionIds,"selectedPermissionIds")
  };

  const handleChangePermissionMob = (selectedOptions) => {
        setSelectedItemsPermission(selectedOptions.map(opt => opt.value));
        const selectedIdsMob = selectedOptions.map(opt => opt.value);
        setPermissionId(selectedIdsMob);
  };
  

  const handleSubmit = async (e) => {
    toast.dismiss();
    e.preventDefault();

    if (validate()) {
    setLoading(true);
    try {
        const payload = {
            ...formData,
            permissionIdList: permissionId,  // Fixed key name here
        };
        const response = await axiosInstance.post('user/role/save', payload);
        if (response.status === 200) {
            if(response.data.status.code===200) {
                toast.success(response.data.status.message);
                setTimeout(() => {
                    history.push('/all-roles');
                }, 2000);
            }else{
                toast.error(response.data.status.message);
            }
        }
        } catch (error) {
            console.error('Error validating OTP:', error);
        }finally {
            setLoading(false);
          }
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setFormData({
        name:"",
        description: ""
    });
    setSelectedItemsPermission([]);
    setPermissionId([]);
    
    // Optionally, reset errors if required
    // setErrors({});
  }
    return (
        <>
            {loading && <Loader />} 
                <div className="content-header">
                    <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6 title-mob">
                        <h1 className="m-0">Add Role</h1>
                        <Link className="btn btn-primary submit-btn" to="/all-roles">All Roles</Link>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                            <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                            <li className="breadcrumb-item active">Add Role</li>
                        </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                <section className="content">
                    <div className="container-fluid border-top pt-4">
                        <form className="row">

                            <div className="col-lg-6 col-12">
                                <div className="form-group">
                                    <label>Name <span>*</span></label>
                                    <input type="text" className="input-fld" name="name" value={formData.name} onChange={handleChange} />
                                    {errors.name && <span className="error">{errors.name}</span>}
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="form-group">
                                    <label>Description <span>*</span></label>
                                    <input type="text" className="input-fld" name="description" value={formData.description} onChange={handleChange} />
                                    {errors.description && <span className="error">{errors.description}</span>}
                                </div>
                            </div>
                            <div className="col-lg-12 col-12">
                                <div className="form-group">
                                    <label>Permission List <span>*</span></label>
                                    {loading ? (
                                    <p>Loading permissions...</p>
                                    ) : (
                                    <DualListBox
                                        options={permissionArr}
                                        selected={selectedItemsPermission}
                                        onChange={handleChangePermission}
                                        className="hideMob"
                                    />
                                    )}
                                    <Select
                                        options={permissionArr.map(p => ({ value: p.id, label: p.value }))}
                                        isMulti
                                        onChange={handleChangePermissionMob}
                                        className="hideweb"
                                    />

                                    {errors.selectedItemsPermission && <span className="error">{errors.selectedItemsPermission}</span>}
                                </div>
                            </div>
                            
                            
                            <div className="col-lg-2 col-6">
                                <button onClick={handleSubmit} className="btn btn-primary submit-btn">Submit</button>
                            </div>
                            <div className="col-lg-2 col-6">
                                <button onClick={handleCancel} className="btn btn-primary cancel-btn">Cancel</button>
                            </div>
                        </form>
                    </div>{/* /.container-fluid */}
                </section>
        </>
    );
}
  
export default AddRole;